import { Icon } from "./Icon";

function HeroGraphic() {
  return (
    <svg className="hero-graphic" viewBox="0 0 720 360" aria-hidden="true">
      <defs>
        <linearGradient id="lineFade" x1="0" x2="1">
          <stop offset="0" stopColor="currentColor" stopOpacity="0" />
          <stop offset=".35" stopColor="currentColor" stopOpacity=".7" />
          <stop offset="1" stopColor="currentColor" stopOpacity=".08" />
        </linearGradient>
        <pattern id="factoryGrid" width="28" height="28" patternUnits="userSpaceOnUse">
          <path d="M28 0H0v28" fill="none" stroke="currentColor" strokeOpacity=".09" />
        </pattern>
      </defs>
      <rect width="720" height="360" fill="url(#factoryGrid)" />
      <g className="hero-graphic__speed-lines" fill="none" strokeLinecap="round" strokeWidth="2">
        <path d="M-190 78h112" />
        <path d="M-270 152h164" />
        <path d="M-155 236h92" />
        <path d="M-240 302h132" />
      </g>
      <g className="hero-graphic__machines" fill="currentColor">
        <path d="M420 300v-82h42v-40h62v122h-24v-74h-32v74Z" />
        <path d="M536 300v-112h52v-40h48v152h-20v-95h-60v95Z" />
        <path d="M650 300v-74h44v74Z" />
      </g>
      <g fill="none" stroke="url(#lineFade)" strokeWidth="2">
        <path d="m38 190 42-72h84l42 72-42 72H80Z" />
        <path d="m210 118 32-54h64l32 54-32 54h-64Z" />
        <path d="m309 221 39-67h78l39 67-39 67h-78Z" />
        <path d="M14 239h61M164 190h142M338 118h120l52 51h110" />
        <path d="M426 221h66l43-76h108l36 62" />
      </g>
      <g className="hero-graphic__nodes" fill="currentColor">
        <circle cx="38" cy="190" r="5"/><circle cx="80" cy="118" r="5"/><circle cx="164" cy="190" r="5"/>
        <circle cx="242" cy="64" r="5"/><circle cx="338" cy="118" r="5"/><circle cx="348" cy="154" r="5"/>
        <circle cx="426" cy="221" r="5"/><circle cx="535" cy="145" r="5"/><circle cx="643" cy="145" r="5"/>
      </g>
    </svg>
  );
}

export function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__texture" aria-hidden="true" />
      <div className="container hero__inner">
        <div className="hero__content">
          <p className="hero__slogan">Technology - Make it Possible</p>
          <h1 id="hero-title">Technology Solutions,<br />Built for Manufacturing</h1>
          <p className="hero__subtitle">Digital Solutions &amp; Technology Demonstration Portal</p>
          <p className="hero__description">This portal provides access to proof-of-concept and departmental demonstration applications developed and evaluated by PRT Technology.</p>
          <div className="hero__actions">
            <a className="button button--primary" href="#applications"><Icon name="apps" />View Applications</a>
            <p className="availability-note"><Icon name="info" />Applications may only be available during scheduled test periods.</p>
          </div>
        </div>
        <div className="hero__visual"><HeroGraphic /></div>
      </div>
    </section>
  );
}
